import React from "react"
import { StyledNavLink } from "./style"

type Props = {
  to: string
  children: React.ReactNode
  className?: string
}

export default function NavigationLink({ ...props }: Props): JSX.Element {
  return <StyledNavLink {...props} />
}
